import React from 'react'
// import { useMediaQuery } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';

// const Testcomp = () => {
//   const isDesktopOrLaptop = useMediaQuery('(min-width: 1224px)');
//   const isBigScreen = useMediaQuery('(min-width: 1824px)');
//   const isTabletOrMobile = useMediaQuery('(max-width: 1224px)');
// //   const isPortrait = useMediaQuery('(orientation: portrait)');
// //   const isRetina = useMediaQuery('(min-resolution: 2dppx)');

//   return (
//     <div>
//       <h1>Device Test!</h1>

//     </div>
//   );
// }
export default function Testcomp() {
    const matches = useMediaQuery('(min-width:600px)');
  
    return <span>{`(min-width:600px) matches: ${matches}`}</span>;
  }
  

// export default Testcomp;